import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Box, Grid, Link } from '@material-ui/core';
import StoreIcon from '@material-ui/icons/Store';
import EmailIcon from '@material-ui/icons/Email';
import { useTranslation } from 'react-i18next';
import { getFullName } from '../../../../utils';
import { ImageCard, PlainLink, Typography } from '../../../../ui-kit';
import img from '../../../../assets/placeholders/employee.png';
import { EmployeeCardProps } from './types';
import { PaddedContainer } from './style';

const EmployeeCard = ({ employee }: EmployeeCardProps) => {
    const { email, id, role, venue } = employee;
    const match = useRouteMatch();
    const { t } = useTranslation();
    const fullname = getFullName(employee);
    const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();

    return (
        <Grid component={PlainLink} item xs={12} sm={6} lg={3} key={id} to={`${match.url}/${id}`}>
            <ImageCard imgAlt={fullname} imgSrc={img}>
                <Typography variant='h6' component="p">
                    {fullname}
                </Typography>
                <Typography variant='body1' gutterBottom component="p">
                    {t(role)}
                </Typography>
                <Box display='flex'>
                    <PaddedContainer>
                        <EmailIcon />
                    </PaddedContainer>
                    <Link onClick={stopPropagation} variant='body1' href={`mailto:${email}`}>
                        {email}
                    </Link>
                </Box>
                <Box display='flex'>
                    <PaddedContainer>
                        <StoreIcon />
                    </PaddedContainer>

                    <Typography variant='body1' component="p">
                        {venue}
                    </Typography>
                </Box>
            </ImageCard>
        </Grid>
    );
};

export default EmployeeCard;
